import React, {useState} from "react";
import {Link} from "react-router-dom";
import NavigationBar from "../NavigationBar";
import {verifyUserCredentials} from "../services/loginService";
import './index.css'
import bcrypt from 'bcryptjs'

// Login Page, where users can login providing the username and password.
const LoginPage = () => {
    const[loginDetail, setLoginDetails] = useState('');

    const PostDetails = () => {

        let loginDetails = {...loginDetail, password: bcrypt.hashSync(loginDetail.password, '$2a$10$CwTycUXWue0Thq9StjUM0u')};
        console.log(loginDetails);
        verifyUserCredentials(loginDetails);
    }
    return(
        <> 
            <NavigationBar/>
            <div className="row w-110 vh-100 gradient-custom">
                        <div className="row d-flex justify-content-center align-items-center w-100">
                            <div className="col-12 col-md-8 col-lg-6 col-xl-5">
                                <div className="card bg-dark text-white">
                                    <div className="card-body p-5 text-center">

                                        <div className="mb-md-5 mt-md-4">

                                        <h2 className="fw-bold mb-2 text-uppercase">Login</h2>
                                        <div className="form-outline form-white mb-4">
                                            <input type="text" id="userName" 
                                            name = "userName" className="form-control form-control-lg" placeholder="Username"
                                            onChange = {e => setLoginDetails((value) => ({...value,[e.target.name] : e.target.value}))} />   
                                        </div>

                                        <div className="form-outline form-white mb-4">
                                            <input type="password" id="typePasswordX" className="form-control form-control-lg" 
                                            placeholder="Password" name="password" onChange = {e => setLoginDetails((value) => ({...value,[e.target.name] : e.target.value}))}/>
                                        </div>

                                        <button className="btn btn-outline-light btn-lg px-5" type="submit" onClick={PostDetails}>Login</button>
                                        </div>

                                        <div>
                                        <p className="mb-0">Don't have an account? 
                                            <Link to='/register' className="text-white-50 fw-bold">Register Here</Link>
                                        </p>
                                        </div>

                                    </div>
                                </div>
                            </div>
                    </div>
            </div>
        </>
    );
}

export default LoginPage;